/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 信用查询历史记录本地存储工具
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-12 21:45:00
 */

const STORAGE_KEY = 'credit_query_history'
const MAX_HISTORY_COUNT = 10 // 最多保存10条记录

export interface HistoryItem {
  id: string
  phone: string
  queriedAt: string
}

/**
 * 获取查询历史记录
 */
export function getCreditHistory(): HistoryItem[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return []
    const history = JSON.parse(stored)
    return Array.isArray(history) ? history : []
  } catch (error) {
    console.error('读取查询历史失败:', error)
    return []
  }
}

/**
 * 添加查询记录到历史
 * @param phone 手机号
 */
export function addCreditHistory(phone: string): void {
  try {
    const history = getCreditHistory()

    // 移除已存在的相同手机号记录（去重）
    const filteredHistory = history.filter((item) => item.phone !== phone)

    // 添加新记录到最前面
    const newItem: HistoryItem = {
      id: Date.now().toString(),
      phone,
      queriedAt: new Date().toISOString()
    }

    const updatedHistory = [newItem, ...filteredHistory].slice(
      0,
      MAX_HISTORY_COUNT
    )

    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory))
  } catch (error) {
    console.error('保存查询历史失败:', error)
  }
}

/**
 * 清除查询历史
 */
export function clearCreditHistory(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error('清除查询历史失败:', error)
  }
}
